import { styled, Typography } from '@mui/material';

// Cuerpo a DOS líneas como máximo: con textos largos la fila crecía sin control y la
// bandeja perdía el ritmo de lectura.
const StyledNotificationBody = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  display: '-webkit-box',
  overflow: 'hidden',
  overflowWrap: 'anywhere',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.typography.pxToRem(12)
  }
}));

export default StyledNotificationBody;
